import { memo, FC, useEffect, useState } from "react";
import { ChallengeTableRowProp } from "@/features/challenge/types/props/SingleChallengeProps";
import { useCurrentUserProfile } from "@/store/auth/userProfile.store";
import { formattedTime } from "../../helperFunctions/formatMsToTime";
import {
  Avatar,
  Box,
  Callout,
  Card,
  Flex,
  Heading,
  Text,
  Tooltip,
} from "@radix-ui/themes";
import { ReactComponent as GoldMedalIcon } from "@/assets/vector/gold.svg";
import { ReactComponent as SilverMedalIcon } from "@/assets/vector/silver.svg";
import { ReactComponent as BronzeMedalIcon } from "@/assets/vector/bronze.svg";

const LeaderboardTableRows: FC<ChallengeTableRowProp> = (
  props
): JSX.Element => {
  const currentUser = useCurrentUserProfile((s) => s.user);
  const isCurrUser = props.slug === currentUser.slug;

  const userName = props.name[0];
  const fullName = props.name[1];

  const currentRank = props.rank;
  const Gold = currentRank === 1;
  const Silver = currentRank === 2;
  const Bronze = currentRank === 3;
  const isTop3 = Gold || Silver || Bronze;

  const points = Number(props.points);

  return (
    <Callout.Root
      variant={isTop3 ? "soft" : "outline"}
      size="1"
      style={{ display: "flex" }}
    >
      <Box width="100%" minWidth="100%" gridColumn="1 / -1">
        <Flex align="center" justify="start" gap="5" wrap="wrap">
          {/* Placement */}
          <Box position="relative">
            <Flex align="center" justify="center">
              {isTop3 ? (
                <>
                  <Tooltip content={`${currentRank}. place`}>
                    <Flex align="center" justify="center">
                      {Gold && <GoldMedalIcon width={32} height={32} />}
                      {Silver && <SilverMedalIcon width={32} height={32} />}
                      {Bronze && <BronzeMedalIcon width={32} height={32} />}
                    </Flex>
                  </Tooltip>
                </>
              ) : (
                <Box minWidth="32px">
                  <Text as="div" align="center" size="3" weight="medium">
                    {props.rank}
                  </Text>
                </Box>
              )}
            </Flex>
          </Box>

          {/* User */}
          <Flex
            align="center"
            gap="3"
            maxWidth={{ initial: "150px", lg: "none" }}
          >
            {/* Avatar */}
            <Avatar
              src={props.logo}
              fallback={userName ? userName.slice(0, 1) : "U"}
              radius="full"
              size="3"
            />

            <Box maxWidth="100%">
              {/* Username */}
              {userName && (
                <Heading as="h4" size="3" my="0" truncate>
                  {userName}
                </Heading>
              )}

              {/* Full name */}
              {fullName && (
                <Text size="2" color="gray" my="0" truncate>
                  {fullName}
                </Text>
              )}
            </Box>
          </Flex>

          {/* Points */}
          <Box ml="auto" pr="3">
            <Text size="2" color="gray">
              {props.game.includes("fm8") || props.pointsType === "ms"
                ? formattedTime(props.points)
                : (() => {
                    const pointsStr = props.points.toString();
                    const decimalLength = pointsStr.includes(".")
                      ? pointsStr.split(".")[1].length
                      : 0;
                    return decimalLength > 2 ? points.toFixed(2) : props.points;
                  })()}
            </Text>
          </Box>
        </Flex>
      </Box>
    </Callout.Root>
  );
};
export default memo(LeaderboardTableRows);
